import type React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import WarningNotificationIcon from '../../icons/notification/warning_notification';

import {
  CardIcon,
  BankIcon,
  CloseIcon,
  CheckCircleRounded,
  ErrorRounded,
  FlagRounded,
  ThumbUpAltOutlined,
  ChevronLeftIcon,
  ArrowBackIos,
  SuccessIcon,
  CheckIcon,
  LocalAtm,
  NavigateNext,
  LaunchIcon,
  ErrorIcon,
  CancelIcon,
  AccessTimeIcon,
  LocalAtmIcon,
  NavigateNextIcon,
  TextsmsOutlined,
  DevicesOutlined,
  EmailOutlined,
  PaymentOutlined,
  PhoneInTalk,
  AllyIcon,
  AmexIcon,
  BankOfAmericaIcon,
  BankOfTheWestIcon,
  BBAndTIcon,
  CapitalOneIcon,
  CharlesSchwabIcon,
  ChaseIcon,
  CITIIcon,
  CitizensBankIcon,
  CvvIcon,
  DiscoverIcon,
  EasyPayIcon,
  FidelityIcon,
  FifthThirdIcon,
  GenericBankIcon,
  GenericCardIcon,
  HuntingtonIcon,
  MastercardIcon,
  NavyFederalIcon,
  NoProviderIcon,
  PaymentChipsIcon,
  PNCIcon,
  RegionsIcon,
  SunTrustIcon,
  TDAmeritradeIcon,
  USAAIcon,
  USBankIcon,
  VisaIcon,
  WellsFargoIcon,
  WarningIcon,
} from './iconsList';

export const iconMap = {
  card: CardIcon,
  bank: BankIcon,
  close: CloseIcon,
  checkCircleRounded: CheckCircleRounded,
  errorRounded: ErrorRounded,
  flagRounded: FlagRounded,
  thumbUpAltOutlined: ThumbUpAltOutlined,
  chevronLeft: ChevronLeftIcon,
  arrowBackIos: ArrowBackIos,
  success: SuccessIcon,
  check: CheckIcon,
  localAtm: LocalAtm,
  navigateNext: NavigateNext,
  launch: LaunchIcon,
  error: ErrorIcon,
  cancel: CancelIcon,
  accessTime: AccessTimeIcon,
  localAtmIcon: LocalAtmIcon,
  navigateNextIcon: NavigateNextIcon,
  textsmsOutlined: TextsmsOutlined,
  devicesOutlined: DevicesOutlined,
  emailOutlined: EmailOutlined,
  paymentOutlined: PaymentOutlined,
  phoneInTalk: PhoneInTalk,
  warningNotificationIcon: WarningNotificationIcon,

  allyIcon: AllyIcon,
  amexIcon: AmexIcon,
  bankOfAmericaIcon: BankOfAmericaIcon,
  bankOfTheWestIcon: BankOfTheWestIcon,
  bbAndTIcon: BBAndTIcon,
  capitalOneIcon: CapitalOneIcon,
  charlesSchwabIcon: CharlesSchwabIcon,
  chaseIcon: ChaseIcon,
  citiIcon: CITIIcon,
  citizensBankIcon: CitizensBankIcon,
  cvvIcon: CvvIcon,
  discoverIcon: DiscoverIcon,
  easyPayIcon: EasyPayIcon,
  fidelityIcon: FidelityIcon,
  fifthThirdIcon: FifthThirdIcon,
  genericBankIcon: GenericBankIcon,
  genericCardIcon: GenericCardIcon,
  huntingtonIcon: HuntingtonIcon,
  mastercardIcon: MastercardIcon,
  navyFederalIcon: NavyFederalIcon,
  noProviderIcon: NoProviderIcon,
  paymentChipsIcon: PaymentChipsIcon,
  pncIcon: PNCIcon,
  regionsIcon: RegionsIcon,
  sunTrustIcon: SunTrustIcon,
  tdAmeritradeIcon: TDAmeritradeIcon,
  usaaIcon: USAAIcon,
  usBankIcon: USBankIcon,
  visaIcon: VisaIcon,
  wellsFargoIcon: WellsFargoIcon,
  warningIcon: WarningIcon,
};

export type IconVariants = keyof typeof iconMap;

// Icon component type
export type IconComponentType =
  React.HTMLAttributes<SVGElement> & SvgIconProps;
